import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { BannerV2 } from "@Front-end/seed/models/v2/banner";
import { LocalizeRouterPipe } from "@gilsdav/ngx-translate-router";
import { TranslateModule } from "@ngx-translate/core";
import { BannerMetadataPipe } from "../../features/home/components/banner-slider/pipes/banner-metadata.pipe";
import { ContentTextByNamePipe } from "../../features/home/components/banner-slider/pipes/content-text-by-name.pipe";
import { PictureComponent } from "../../modules/shared/picture/picture.component";
import { ResolveMinioUrlMirrorPipe } from "../../pipes/resolve-minio-url-mirror.pipe";

@Component({
    selector: "ls-new-feature-banner",
    templateUrl: "./new-feature-banner.component.html",
    styleUrls: ["./new-feature-banner.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        PictureComponent,
        ResolveMinioUrlMirrorPipe,
        ContentTextByNamePipe,
        TranslateModule,
        LocalizeRouterPipe,
        RouterLink,
        BannerMetadataPipe,
    ],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        class: "new-feature-banner",
    },
})
export class NewFeatureBannerComponent {
    public banner = input.required<BannerV2>();
    public redirectUrl = computed(() => this.banner().redirectUrl || "");
    public lsOnLinkClick = output<void>();

    public linkClick(): void {
        this.lsOnLinkClick.emit();
    }
}
